import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notice-press10',
  templateUrl: './notice-press10.component.html',
  styleUrls: ['./notice-press10.component.scss']
})
export class NoticePress10Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
